// import React, { useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import Header from './Header';

// function Protected({ children }) {
//   const navigate = useNavigate();

//   useEffect(() => {
//     if (!localStorage.getItem('user-info')) {
//       navigate('/login');
//     }
//   }, [navigate]);

//   return (
//     <>
//       {/* <Header /> */}
//       {children}
//       </>
//   );
// }

// export default Protected;


import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './context//AuthContext'; // Import the custom AuthContext hook

function Protected({ children, requiredRoles = [], requiredPermissions = [] }) {
  const navigate = useNavigate();
  const { roles, permissions, user } = useAuth(); // Access user roles and permissions from AuthContext

  useEffect(() => {
    // Redirect if no user is logged in
    if (!localStorage.getItem('user-info')) {
      navigate('/login');
      return;
    }

    // Check if the user has the required role
    const hasRequiredRole = requiredRoles.length === 0 || requiredRoles.some(role => roles.includes(role));

    // Check if the user has the required permissions
    const hasRequiredPermission = requiredPermissions.length === 0 || requiredPermissions.every(permission => permissions.includes(permission));

    // Redirect if the user doesn't have the required roles or permissions
    if (!hasRequiredRole || !hasRequiredPermission) {
      navigate('/unauthorized'); // Or redirect to a "forbidden" page
    }
  }, [navigate, roles, permissions, requiredRoles, requiredPermissions]);

  return (
    <>
      {children}
    </>
  );
}

export default Protected;
